import apiClient from './apiClient'

export const logoutUser = async (): Promise<void> => {
  try {
    await apiClient.get('/logout')
  } catch (error) {
    console.error('Error logging out:', error)
    throw error
  }
}

export const getAccessToken = async (code: string): Promise<void> => {
  try {
    await apiClient.get(`/access_token?code=${code}`)
  } catch (error) {
    console.error('Error getting access token:', error)
    throw error
  }
}

export const getRefreshToken = async (): Promise<string> => {
  try {
    const response = await apiClient.get<{ token: string }>('/refresh_token')
    return response.data.token
  } catch (error) {
    console.error('Error refreshing token:', error)
    throw error
  }
}
